import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TRANSACTION_TYPE } from '@/constants/Transaction';
import { gettext } from '@/utils/langsBook';
import Tooltip from '@/components/combined/ToolTip';
import Icon from '@/components/base/Icon';
var TransactionTitleTip = function(props) {
    var title = (props || {}).title;
    return(/*#__PURE__*/ _jsxs("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-[24px] font-bold leading-[29px]",
                children: title
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                options: Object.values(TRANSACTION_TYPE).map(function(t) {
                    /*#__PURE__*/ return _jsxs("div", {
                        className: "w-[192px] py-[10px]",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: t,
                                className: "text-[24px] text-[#6A7394] mx-[12px]"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[15px] text-[#6A7394]",
                                children: gettext(t)
                            })
                        ]
                    }, t);
                }),
                target: /*#__PURE__*/ _jsx(Icon, {
                    type: "tips",
                    className: "text-[24px] ml-[10px] text-desc hover:text-primary cursor-pointer"
                }),
                placement: "bottomLeft"
            })
        ]
    }));
};
export default TransactionTitleTip;
